import React from 'react';

// A code as the floor prints it: letters and digits joined by hyphens (A-01, REC-000090, POL-1).
const CODE = /([A-Za-z0-9]+(?:-[A-Za-z0-9]+)+)/;

/**
 * Text whose codes do not break at a hyphen. The browser may end a line right
 * after one, and «A-» over «01» no longer reads as the slot. Each code moves
 * to the next line whole, and only one longer than the line itself breaks.
 * Only the line breaks change: the words stay the same.
 *
 * @param {object} props
 * @param {string} props.text
 */
export const CodeText = ({ text }) => (
  <>
    {String(text ?? '')
      .split(CODE)
      .map((part, index) =>
        index % 2 === 1 ? (
          <span key={index} className="inline-block max-w-full [overflow-wrap:anywhere]">
            {part}
          </span>
        ) : (
          part
        )
      )}
  </>
);
